<template>
  <el-container>
    <el-main :style="mainstyle">
      <table style="width:100%;height:100%;margin:auto">
        <tbody>
        <tr>
          <td>
            <img class="img_wanzhuan" :style="logimgstyle" :src="loginimg">
            <el-form :model="form" label-position="left" label-width="0px" class="loginarea" :style="loginareastyle" :rules="rules" style="background-image: url(/static/img/login/textbg.png);" ref="form1">
              <h3 class="logintitle">系统登录<div style="float: right;font-size: x-small"><a href="/static/file/安全登录助手.zip" target="_blank">下载安全登录助手</a></div></h3>
              <el-form-item prop="LoginName">
                <el-input prefix-icon="el-icon-mobile-phone" type="text" v-model="form.LoginName"
                          auto-complete="off"
                          placeholder="请输入手机号"
                          v-focus="{ cls: 'el-input',tag: 'input', foc: focususername }"
                          v-on:blur="focususername=false"></el-input>
              </el-form-item>
              <el-form-item prop="PassWord">
                <el-input prefix-icon="el-icon-edit-outline" type="password" v-model="form.PassWord"
                          auto-complete="off"
                          placeholder="请输入密码"
                          v-focus="{ cls: 'el-input',tag: 'input', foc: focuspassword }"
                          v-on:blur="focuspassword=false" @keyup.native.enter="login"></el-input>
              </el-form-item>
              <el-form-item style="width:100%;">
                <el-button type="primary" style="width:80%;" @click.native.prevent="login" :disabled="hasSubmit">登录</el-button>
              </el-form-item>
              <el-checkbox class="login_remember" checked v-model="checked" label-position="left">记住密码
              </el-checkbox>
             <a class="Register BottomFont" @click="ShowRegister">设置/修改密码</a>
            </el-form>
            <TenantList ref="TenantList" :datalist="tenantlist" @selectTenant="selectTenant"></TenantList>
            <RegisterPW ref="RegisterPW" :tenantid="beforelogintenantid"
                        @AfterRegister="AfterRegister"></RegisterPW>
          </td></tr></tbody></table>
    </el-main>
    <el-footer style="background-color: unset">Copyright © {{yearflag}} <a href="https://beian.miit.gov.cn/" target="_blank">{{ICP}}</a></el-footer>
  </el-container>
</template>
<script>
  import TenantList from './TenantList'
  import RegisterPW from './RegisterPW'
  import {login, setTenant, getTenantSet,logout} from '../../api/login'

  export default {
    name: "login",
    data() {
      return {
        loginparam: [],
        hasSubmit: false,
        logimgstyle:'',
        loginareastyle:'',
        formLabelWidth: '120px',
        tenantlist: [],
        applist: [],//应用集合
        loginimg: '',
        beforelogintenantid: '',
        yearflag: 2021,
        ICP: '',
        mainstyle: '',
        form: {
          LoginName: '',//18951936622
          PassWord: '',//88888
        },
        checked: true,
        rules: {
          LoginName: [
            {required: true, message: '请输入账号', trigger: 'blur'},
          ],
          PassWord: [
            {required: true, message: '请输入密码', trigger: 'blur'},
          ]
        },
        focususername: false,
        focuspassword: false,
        machinecode: '',//机器码
      }
    },
    methods: {
      //获取本地机器码
      StartWebSocket() {
        var that = this
        var url = "ws://127.0.0.1:5000/";
        var ws = ''
        if ('WebSocket' in window) {
          ws = new WebSocket(url);
        } else if ('MozWebSocket' in window) {
          ws = new MozWebSocket(url);
        }
        ws.onopen = function () {
          // this.m_isConnectWS = true;
          console.log("Connection open ...");
          var msg = "{\"method\":\"getregistercode\"}";
          ws.send(msg);
        };
        ws.onerror = function () {
          console.log("Connection error ...");
        }
        ws.onmessage = function (e) {
          var data = e.data;
          that.machinecode = data
        }
        ws.onclose = function () {
          // this.m_isConnectWS = false;
          console.log("连接中断");
        };
      },
      login(tenantid1) {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            if (this.hasSubmit)
              return;
            this.hasSubmit = true;
            //判断复选框是否被勾选 勾选则调用配置cookie方法
            if (this.checked) {
              //传入账号名，密码，和保存天数3个参数
              this.setCookie(this.form.LoginName, this.form.PassWord, 7);
            } else {
              this.clearCookie();
            }

            //调用登录接口
            login({
              loginName: this.form.LoginName,
              password: this.form.PassWord,
              LoginFrom: this.$route.name == "loginsupply" ? "supply" : "pc"
            }).then(response => {
              setTimeout(() => {
                this.hasSubmit = false;
              }, 2000);
              if (response.data.code == 0) {//全局登录成功
                localStorage.setItem("hpapi_token", response.data.token);
                var tokenInfo = response.data.obj;
                var tenantDoOld = tokenInfo.tenantDO;
                var tenantDoNew =[]
                var duliSite='hoya100.eyes.wang';
                if (window.location.host.indexOf('localhost') > -1) {//本地调试用
                  duliSite='';
                }

                if(window.location.host==duliSite) {
                  for (var i in tenantDoOld) {
                    if (tenantDoOld[i].website == duliSite) {
                      tenantDoNew.push(tenantDoOld[i]);
                    }
                  }
                }else {
                  for (var i in tenantDoOld) {
                    if (tenantDoOld[i].website != duliSite) {
                      tenantDoNew.push(tenantDoOld[i]);
                    }
                  }
                }
                tokenInfo.tenantDO=tenantDoNew;

                tokenInfo.attviewpath = this.loginparam.attviewpath
                localStorage.setItem("hpapi_tokenModel", JSON.stringify(tokenInfo));
                if (tokenInfo.tenantDO.length == 1) {
                  var tenantDo = tokenInfo.tenantDO[0];
                  this.selectTenant(tenantDo.unitguid, tenantDo.uguid, tenantDo.appguid, tenantDo.appurl, tenantDo.appname, tenantDo.apiurl);
                } else {//存在多个
                  this.tenantlist = tokenInfo.tenantDO;
                  this.$refs.TenantList.dialogFormVisible = true;
                }
              } else {
                this.focususername = true;
                this.$message.error({message: response.data.msg});
              }
            }).catch((error) => {
              this.focususername = true;
              console.log(error)
            });
          } else {
            this.focususername = true;
            this.$message.error('请核对手机号、密码是否正确!!')
            return false;
          }
        });
      },
      AfterRegister(mobile) {
        this.form.LoginName = mobile;
        this.form.PassWord = '';
      },
      ShowRegister() {
        this.$refs.RegisterPW.show();
      },
      selectTenant(tenantID, uguid, appguid, appurl, appname, apiurl) {
        if (window.location.host.indexOf('localhost') > -1) {//本地调试用
          appurl = 'http://' + window.location.host + '/#/index'
          apiurl = ''
        } else if (window.location.host == 'b2btest.shuziyanjing.com') {//测试环境，停留当前域名
          appurl = window.location.protocol + '//' + window.location.host
          apiurl = ''
        }
        setTenant({
          appguid: appguid,
          tenantID: tenantID,
          machinecode: this.machinecode,//机器码
          uguid: uguid,
          apiurl: apiurl,
          isAppChanged: true,
        }).then(responseUser => {
          if (responseUser.data.code == 0) {
            localStorage.setItem("hpapi_userInfoModel", JSON.stringify(responseUser.data.obj));
            document.title = responseUser.data.obj.tenantname + "【" + appname + "】";
            localStorage.setItem("tenantid", tenantID);
            //跳转到指定路由
            var RoutePath = '';
            let tokenModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
            var tenantModel = tokenModel.tenantDO;
            for (var i = 0; i < tenantModel.length; i++) {
              if (tenantModel[i].unitguid == responseUser.data.obj.tenantid && tenantModel[i].uguid == responseUser.data.obj.uguid)
                RoutePath = tenantModel[i].mainurl;
            }
            if (window.location.host == 'b2btest.shuziyanjing.com') {
              RoutePath = '';// 测试域名，不跳转后台配置的 mainurl，停留当前域名
            }
            if (RoutePath && RoutePath != '') {
              window.location.href = RoutePath;// this.$route.params.redirect
            } else {
              if (tokenModel.loginfrom == "supply") {
                this.$router.push({"name": "SupplyProfit"});// 供应商账户登录
              } else {
                localStorage.setItem("appguid", appguid);
                var baseUrl = appurl.split('#')[0];
                window.location.href = baseUrl + '#/?appguid=' + appguid
                  + '&token=' + localStorage.getItem("hpapi_token");
              }
            }
          } else {//获取错误
            this.focususername = true;
            this.$message({
              message: responseUser.data.msg,
              type: 'error',
              duration: 15000,
            });
          }
        });
      },
      cancel() {
        localStorage.removeItem("hpapi_token");
        localStorage.removeItem("hpapi_tokenModel");
        localStorage.removeItem("hpapi_userInfoModel");
      },
      logout() {
        if (localStorage.getItem("hpapi_token")) {
          logout({}).then(response => {
            localStorage.removeItem("appguid");
            localStorage.removeItem("tenantid");
            localStorage.removeItem("hpapi_token");
            localStorage.removeItem("hpapi_tokenModel");
            localStorage.removeItem("hpapi_userInfoModel");
          }).catch((error) => {
            console.log(error)
          });
        }
      },
      setCookie(c_name, c_pwd, exdays) {
        var exdate = new Date();//获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);//保存的天数
        //字符串拼接cookie
        window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      },
      //读取cookie
      getCookie: function () {
        if (document.cookie.length > 0) {
          var arr = document.cookie.split('; ');//这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('=');//再次切割
            //判断查找相对应的值
            if (arr2[0] == 'userName') {
              this.form.LoginName = arr2[1];//保存到保存数据的地方
            } else if (arr2[0] == 'userPwd') {
              this.form.PassWord = arr2[1];
            }
          }
        }
      },
      //清除cookie
      clearCookie: function () {
        this.setCookie("", "", -1);//修改2值都为空，天数为负1天就好了
      }
    },
    mounted() {
      this.getCookie();
      this.StartWebSocket();
      this.logout();
      var host = window.location.host;
      this.loginimg = '';
      getTenantSet({"website": host}).then(reponse => {
        this.loginparam = reponse.data;
        if (reponse.data.apiset.cssurl) {
          this.mainstyle = 'background: url(/static/img/login/' + reponse.data.apiset.cssurl + ')  no-repeat center center; background-size: 100% 100%;';
          if (reponse.data.apiset.cssurl.indexOf('left') > -1) {
            this.logimgstyle = 'display:none';
            this.loginimg = '';
            this.loginareastyle = 'float:left;margin-left: 150px';
          } else {
            this.loginimg = reponse.data.apiset.loginimg;
          }
        } else {
          this.loginimg = reponse.data.apiset.loginimg;
          this.mainstyle = 'background: url(/static/img/login/bg_caiw.jpg)  no-repeat center center; background-size: 100% 100%;';
        }
        localStorage.setItem("zyjthemecssurl", reponse.data.apiset.cssurl);

        document.title = reponse.data.tenantname;
        this.beforelogintenantid = reponse.data.tenantid;
      });
      this.yearflag = new Date().getFullYear();
      if (host.indexOf("shaop.shop") > -1) {
        this.ICP = " 沪ICP备2021007486号-2";
      } else if (host.indexOf("eyes.wang") > -1) {
        this.ICP = "苏ICP备19004653号-1";
      } else if (host.indexOf("shuziyanjing.com") > -1) {
        this.ICP = "苏ICP备2022025057号-2";
      }  else if (host.indexOf("yougoujingcang.com") > -1) {
        this.ICP = "辽ICP备2026017904号-1";
      }if (host.indexOf("shjhgx.cn") > -1) {
        this.ICP = "苏ICP备2025177869号-1";
      } else {
        this.ICP = " 苏ICP备16001801号-1";//zyanjing.com
      }
      this.focususername = true;
    },
    components: {
      TenantList,
      RegisterPW
    }
  }
</script>

<style scoped>
  .el-main {
  padding: 0px;
  width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  height: 100%;
  line-height: 100%;
  position: fixed;
  text-align: center;
}

.el-input {
  width: 80%;
  font-size: 16px;
  color: #333333;
}

.el-form-item__error {
  padding-left: 40px !important;
}


.logintitle {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  padding-left: 20px;
  font-weight: bold;
  color: #333;
  letter-spacing: 5px;
  text-align: left;
}

.BottomFont {
  color: #409EFF;
  float: right;
  padding-right: 60px;
  font-size: 14px;
  cursor: pointer;
}

.el-footer {
  padding: 0px;
  background-color: #ffffff;
  height: 60px;
  font-size: 14px;
  color: #4f616e;
  text-align: center;
  line-height: 60px;
  position: fixed;
  bottom: 0px;
  width: 100%;
}

.img_wanzhuan {
  margin-top: 5%;
}

.loginarea {
  float: right;
  margin-right: 18%;
  width: 380px;
  height: 380px;
  background-position: center center;
  background-repeat: no-repeat;
}

</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue